import React, { Fragment, useEffect, useState } from 'react'
import "./AddOrViewTransmission.css"
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { getInstitutionsCategoriesCreated, getAgent, getRoles, getAgents, updateAgent, addAgent, getInstitutionsOfCategory, getLastTransmissionDate, getInstitutionsProducts, addTaux, viewTauxProducts } from '../../services/http';
import { useNavigate, useParams } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection, reload } from '../../utils/utils';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import Navbar from '../../appShell/Navbar/Navbar';
import Select, { StylesConfig } from 'react-select';
import { FaArrowAltCircleLeft } from "react-icons/fa";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr';
import Loader from '../Loader/Loader';
import ProcessSpinner from '../ProcessSpinner/ProcessSpinner';


const AddOrViewTransmission = (props) => {

    const { operationType } = props;
    const navigate = useNavigate();
    const id_transmission = useParams()
    registerLocale('fr', fr)
    const [transmissionDate, setTransmissionDate] = useState(new Date());

    const [agent, setAgent] = useState({ nom: "", postNom: "", prenom: "", sexe: "", telephone: "", email: "", categorieInstitution: "", institution: "", password: "", type: "", role: "" });

    const [products, setProducts] = useState();

    const [tauxMax, setTauxMax] = useState()
    const [disabledBtn, setDisabledBtn] = useState(false)


    const [lastDateTransmission, setLastDateTransmission] = useState("")
    const [displayLoader, setDisplayLoader] = useState(true)
    const [processOngoing, setProcessOngoing] = useState(false)

    // To populate the breadcrumb and update the sidebar menu
    useEffect(() => {
        let type;
        if (operationType == "new") { type = "Ajout" } else { type = "Visualisation" }
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Transmission", firstLevelLink: "/transmission", secondLevelText: type, secondLevelLink: "transmission/new", thirdLevelText: "", thirdLevelLink: ""
            }
        });
        handleMenuSelection("transmission", dispatch, states);
        // handleSubMenuSelection("users", dispatch)
    }, [])

    const loadLastDateTransmission = async () => {
        const response = await getLastTransmissionDate(states.userToken.access_token)
        if (response.response && response.response.status !== 200) {
            console.log("last Date of transmission error ", response.response)
        } else {
            console.log("Last date of transmission data ", response.data)

            var splitResponse = response.data.split("-")
            var reconstructedResponse = splitResponse[1] + "/" + splitResponse[0]
            setLastDateTransmission(new Date(`${parseInt(splitResponse[1]) - 1}/15/${splitResponse[0]}`))
            // console.log(parseInt(splitResponse[1]) + 1)
            // setLastDateTransmission(reconstructedResponse)
            console.log(`${splitResponse[1]}/10/${splitResponse[0]}`)
        }
    }

    const loadInstitutionsProducts = async () => {
        const response = await getInstitutionsProducts(states.userToken.access_token)
        if (response.response && response.response.status !== 200) {
            console.log("Instituitions products error ", response.response)
        } else {
            console.log("Instituitions products data ", response.data)
            setTauxMax(parseInt(response.data.taux_maximal))
            setProducts(response.data)
            var newData = response.data?.product?.map(value => ({
                product_id: value.id,
                libelle: value.libelle,
                taux: null
            }))
            console.log("New Data ", newData)
            dispatch({
                type: "SET",
                key: "tauxProduits",
                payload: newData,
            });

            setDisplayLoader(false)
        }
    }

    useEffect(() => {
        if (operationType === "new") {

            loadLastDateTransmission();
            loadInstitutionsProducts();
        }
        return () => {
            dispatch({
                type: "SET",
                key: "tauxProduits",
                payload: {}
            });
        }
    }, [])

    useEffect(async () => {
        if (operationType !== "new") {


            const response = await viewTauxProducts(id_transmission, states.userToken.access_token)
            if (response.response && response.response.status !== 200) {
                console.log("Taux products error ", response.response)
            } else {
                console.log("Taux data ", response.data)

                // setProducts(response.data)
                var newData = response.data.taux.map(value => ({
                    product_id: value.product?.id,
                    libelle: value.product?.libelle,
                    taux: value.taux,
                }))
                console.log(response.data?.transmission?.mois)
                const mois = parseInt(response.data?.transmission?.mois);
                console.log(mois)
                setTransmissionDate(new Date(`${mois}/28/${response.data?.transmission?.annee}`))

                dispatch({
                    type: "SET",
                    key: "tauxProduits",
                    payload: newData,
                });
                setDisplayLoader(false)

            }
        }
    }, [])




    const dispatch = useDispatch();

    const states = useSelector((state) => state, shallowEqual);

    const handleInputChange = (id, e) => {


        console.log(id)
        const value = e.currentTarget.value;
        console.log(value)
        let index = states.tauxProduits.findIndex(x => x.product_id === id);
        console.log("index is : ", index)
        let newTableData = [...states.tauxProduits];
        newTableData[index].taux = value;
        dispatch({
            type: "SET",
            key: "tauxProduits",
            payload: newTableData,
        });
        console.log(states.tauxProduits)

        if (value > tauxMax) {
            setDisabledBtn(true)
        } else {
            setDisabledBtn(false)
        }

    };

    //   useEffect(() => {
    //       console.log(transmissionDate)
    //       console.log(transmissionDate.getFullYear())
    //     }, [transmissionDate])

    const handleAddTransmission = async () => {
setProcessOngoing(true)
        console.log(lastDateTransmission.getMonth())
        console.log(transmissionDate.getMonth() + 1)
        if (lastDateTransmission?.getMonth() !== transmissionDate?.getMonth() + 1 || !lastDateTransmission.getMonth()) {
            var products = states.tauxProduits.map(item => ({
                taux: item.taux,
                product_id: item.product_id,
            }))
            var transmissionMonth = transmissionDate.getMonth() + 1;
            // console.log(first)
            const mois = transmissionMonth > 9 ? transmissionMonth : "0" + transmissionMonth;
            const year = transmissionDate.getFullYear();
            console.log("New Data ", products)
            const dataToSend = {
                // user_id: states.userInfo.id,
                mois: mois,
                annee: year,

                products: products
            }

            console.log(dataToSend)
            const reqdata = await addTaux(dataToSend, states.userToken.access_token);
            if (reqdata.response && reqdata.response.status !== 200) {
                if (reqdata.response.status === 422) {
            setProcessOngoing(false)
                    // console.log(reqdata.response)
                    toast.error("Veuillez renseigner tous les taux.", {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                if (reqdata.response.status === 500) {
            setProcessOngoing(false)
                    //    Should redirect to an Error Page
                    // console.log(reqdata.response)
                    toast.error("Veuillez respecter le taux maximal pour tous les taux.", {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
            } else {
            setProcessOngoing(false)
                // console.log(reqdata)
                toast.success(reqdata.data, {
                    position: toast.POSITION.TOP_RIGHT
                });
                navigate("/transmission")
            }
        } else {
            setProcessOngoing(false)
            toast.warning("Transmission des taux déjà effectuée pour le mois en cours.", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const handleBack = () => {
        navigate("/transmission")
    }

    const handlePreventLetters = (e) => {
        const ALLOWED_CHARS_REGEXP = /^[0-9.]+$/;
        if (!ALLOWED_CHARS_REGEXP.test(e.key)) {
            e.preventDefault();
        }
    }



    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    <div className="layout-px-spacing">

                        <div className="row layout-top-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div>
                        </div>
                        <div className="row pl-3">
                            <button className="btn btn-rounded mr-2" onClick={() => { navigate("/transmission") }}><FaArrowAltCircleLeft className="mr-1" /> Retour</button>
                        </div>
                        {displayLoader == false ?
                            <div className="widget widget-content widget-content-area mt-3" id="add-edit-transmission">
                                <div className="">
                                    <h5 className="modal-title py-1 pl-3 mb-2 text-left " id="exampleModalLabel">{operationType == "new" ? "Nouvelle Transmission" : "Voir Transmission"}</h5>
                                    <hr />
                                    <p className="d-flex flex-nowrap text-center pl-3 my-3"><div className="pt-1">Transmission de : </div><div className="ml-2">
                                        <DatePicker
                                            disabled={operationType === "new" ? false : true}
                                            selected={transmissionDate}
                                            onChange={(date) => setTransmissionDate(date)}
                                            dateFormat="MM/yyyy"
                                            locale="fr"
                                            minDate={lastDateTransmission === "" ? new Date("01/01/2000") : new Date(lastDateTransmission)}
                                            // minDate={lastDateTransmission}
                                            maxDate={new Date()}
                                            placeholderText="Cliquez"
                                            showMonthYearPicker
                                            showFullMonthYearPicker
                                        />
                                    </div> </p>
                                </div>
                                <div className="products-container">
                                    {Object.keys(states.tauxProduits).length !== 0 ? states.tauxProduits.map((product, index) =>
                                        <Fragment>
                                            {/* {JSON.stringify(index)} */}
                                            <div key={product.product_id+index} class="input-group mb-2 row col-xs-12 col-sm-9  mx-auto d-flex flex-nowrap">
                                                <div class="input-group-prepend border-right-none" style={{ width: "80%", borderRadius: "5px 0 0 5px" }}>
                                                    <span style={{ border: product.taux > tauxMax ? "2px solid red" : "" }} class={index % 2 ? "input-group-text w-100 border-right-none input-mix-color" : "input-group-text w-100 border-right-none"} id="basic-addon7">{product.libelle}</span>
                                                </div>
                                                <input
                                                    onKeyPress={handlePreventLetters}
                                                    style={{ border: product.taux > tauxMax ? "2px solid red" : "", fontWeight: "600", color: "#000000", borderRadius: "0px", borderColor: index % 2 && "#0E1726", height: index % 2 ? 29 : 30 }}
                                                    disabled={operationType === "new" ? false : true}
                                                    type="number"
                                                    value={product.taux} onChange={(e) => handleInputChange(product.product_id, e)}
                                                    class={index % 2 ? "form-control custom-form-control product-input border-left-none border-right-none add-edit-tranbsmission-input-height-mixed" : "form-control custom-form-control product-input border-left-none border-right-none add-edit-tranbsmission-input-height"} placeholder="" />
                                                <div className={index % 2 ? "input-group-prepend border-left-none" : "input-group-prepend border-left-none "} style={{ width: "8%" }}>
                                                    <span style={{ border: product.taux > tauxMax ? "2px solid red" : "", borderRadius: "0 5px 5px 0" }} class={index % 2 ? "input-group-text w-100 border-left-none input-mix-color" : "input-group-text w-100 border-left-none"} id="basic-addon7">%</span>
                                                </div>
                                            </div>
                                            {product.taux > tauxMax && <p className="text-danger">`Le taux maximal autorisé par la BCC est {tauxMax}%`</p>}
                                        </Fragment>
                                    ) : <h2>Aucun Produit</h2>
                                    }

                                </div>
                                <div className="text-right w-80 mx-auto py-3">
                                {processOngoing == false ? <Fragment>
                                    {operationType === "new" && <button disabled={disabledBtn} className="btn btn-primary" onClick={handleAddTransmission}>Enregistrer et Transmettre à la BCC </button>
                                    }
                                    </Fragment> : <ProcessSpinner />}
                                </div>

                            </div> :
                            <div style={{ marginTop: "25%" }}>
                                <Loader />
                            </div>}
                    </div>

                </div>
            </div>
        </div>



    )
}

export default AddOrViewTransmission